import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import ErrorComponentPage from "./ErrorComponentPage";
import ErrorRoutePage from "./ErrorRoutePage";


const ErrorBoundaryComponent = () => {
  const error = useRouteError();

  // More info: https://stackoverflow.com/a/78954723

  return isRouteErrorResponse(error) ? 
    <ErrorRoutePage /> : <ErrorComponentPage status={500}/>
}

export default ErrorBoundaryComponent;